// Mock/placeholder data for Rampart Partners Inc website

import { Briefcase, TrendingUp, Building2, Handshake, Target, LineChart, ShieldCheck, Compass } from "lucide-react";

export const company = {
  name: "Rampart Partners Inc",
  shortName: "Rampart Partners Inc",
  tagline: "Strategic Counsel for Defining Moments",
  description:
    "We partner with founders, owners, and executives at the inflection points of their business — strategy, growth, and transaction events that shape the next decade.",
  email: "hello@rampartpartners.com",
  phone: "614-440-0929",
  address: "151 Mill St., Suite 406, Columbus, OH 43230",
  founded: "2008",
  logoUrl: "/rampart-logo.png",
  logoMark: "/rampart-castle.png",
};

export const navLinks = [
  { id: "services", label: "Services" },
  { id: "about", label: "About" },
  { id: "team", label: "Leadership" },
  { id: "contact", label: "Contact" },
];

export const services = [
  {
    id: "transactions",
    icon: Handshake,
    title: "Buying, Selling or Funding Businesses",
    summary:
      "Sell-side, buy-side and capital raises — we have been on all sides of the transactions, and that is our value statement for you.",
    points: [
      "Sell-side searches and anonymous assessments",
      "Buy-side searches for qualified strategic buyers",
      "Venture Capital",
      "Private Equity",
      "Alternative Funding",
    ],
  },
];

export const differentiators = [
  {
    icon: Briefcase,
    title: "Senior Practitioners",
    text: "Every engagement is led by a partner who has sat in the operator's chair.",
  },
  {
    icon: ShieldCheck,
    title: "Aligned Incentives",
    text: "Transparent fee structures and outcomes-based engagement models.",
  },
  {
    icon: LineChart,
    title: "Quant + Qualitative",
    text: "We pair rigorous analysis with the judgment that only comes from experience.",
  },
  {
    icon: Target,
    title: "Discretion First",
    text: "We work confidentially, often without ever being named in the deal.",
  },
];

export const stats = [
  { value: "150+", label: "Engagements Delivered" },
  { value: "98%", label: "Repeat & Referral Clients" },
  { value: "25 yrs", label: "Average Partner Experience" },
];

export const team = [
  {
    id: "1",
    name: "Tom Clancy",
    role: "Managing Partner",
    focus: "",
    bio: "Tom leads Rampart Partners with hands-on involvement in every engagement. He draws from his 15 years of experience at Rampart Partners, as well as sitting in the CEO, President, CTO, Director, and other leadership seats in his own and other large global companies. Tom pulls together a specific team based upon each client's needs and strategies — from inside the company and from outside trusted resources.",
    initials: "TC",
    image: "/tom-clancy.jpg",
    linkedin: "https://www.linkedin.com/in/tom-clancy-b2158627/",
  },
  {
    id: "2",
    name: "Bob Rutkowski",
    role: "Senior Partner",
    focus: "",
    bio: "Bob Rutkowski founded Rampart Partners in 2005 and led the company through countless successful engagements. He plays an advisory role today and is engaged with the teams with insight and knowledge. Bob owned multiple companies and built on his career in the Securities Industry.",
    initials: "BR",
    image: "/bob-rutkowski.jpg",
    linkedin: "https://www.linkedin.com/in/bob-rutkowski-84a179b/",
  },
];

export const testimonials = [
  {
    quote:
      "Rampart didn't sell us a process — they brought a point of view. They reshaped the deal, and we closed at a multiple no one in the room thought was possible.",
    author: "CEO, Industrial Services Platform",
    deal: "Sell-side, $310M Enterprise Value",
  },
  {
    quote:
      "What separates this team is judgment. They told us what we needed to hear, then helped us build the plan to act on it.",
    author: "Founder, B2B SaaS",
    deal: "Growth Equity Raise, Series C",
  },
];

export const heroMedia = {
  background:
    "https://static.prod-images.emergentagent.com/jobs/dd8fd04b-6200-4a1b-bded-a739616e5555/images/2886cbffeea837cb6a63176ced18dfcd8c104ad0f03b542a1ca458ed4034917b.png",
};

export const aboutMedia = {
  partnership:
    "https://static.prod-images.emergentagent.com/jobs/dd8fd04b-6200-4a1b-bded-a739616e5555/images/64d2f692af22f768e01c79c29ddb48ae6dcb852b8b691946e163f5a0d9439e2b.png",
  boardroom:
    "https://images.unsplash.com/photo-1573167507387-6b4b98cb7c13?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  skyscraper:
    "https://images.unsplash.com/photo-1443527394413-4b820fd08dde?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const sectorIcons = { Briefcase, TrendingUp, Building2 };
